import { render, staticRenderFns } from "./ClaimPaymentAdd.vue?vue&type=template&id=5c33a5b3&scoped=true&"
import script from "./ClaimPaymentAdd.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentAdd.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimPaymentAdd.vue?vue&type=style&index=1&id=5c33a5b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33a5b3",
  null
  
)

export default component.exports